var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMarkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13 0 0 3.443 0 7.7C0 13.475 7 22 7 22C7 22 14 13.475 14 7.7C14 3.443 10.87 0 7 0ZM7 10.45C5.62 10.45 4.5 9.218 4.5 7.7C4.5 6.182 5.62 4.95 7 4.95C8.38 4.95 9.5 6.182 9.5 7.7C9.5 9.218 8.38 10.45 7 10.45Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerIcon);
export default __webpack_public_path__ + "static/media/LocationMarkerIcon.3d11179c0542d34b4bd74fb67ec7b5d5.svg";
export { ForwardRef as ReactComponent };